<template>
<div id="app" >
  <a-layout >
    <a-layout-content>
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;

Vue.use(Antd);


export default {
  name: 'App',
}
</script>

<style lang="scss">
@custom-media --sm-mobile(max-width: 320px);
@custom-media --md-mobile(max-width: 480px);
@custom-media --tablet(max-width: 768px);
@custom-media --desktop(max-width: 1024px);

.ant-layout-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 30px;
  font-size: 18px;
  background-image: url(./assets/bg.png);
  background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
}

.center {
  display: grid;
  place-items: center;
}
</style>
